<template>
    <div class="t-shops-row" :class="{ 't-shops-row--active': active }">
        <ui-checkbox-input
            class="text-primary"
            :name="`shop-${shop.entityData.id}`"
            v-model="active"
            :label="`${shop.entityData.name}, ${shop.entityData.address}`"
            :disabled="shop.status === 'active'"
        />
    </div>
</template>

<script>
export default {
    props: {
        shop: {
            type: Object,
            require: true
        }
    },
    computed: {
        active: {
            get() {
                if (this.shop.checked) {
                    return true
                } else {
                    return false
                }
            },
            set() {
                this.$store.dispatch('selectServiceShop', this.shop)
            }
        }
    }
}
</script>
